
export const MOST_SERIOUS_OUTCOME = {
    1: 'Death',
    2: 'Days away from work',
    3: 'Job transfer or restriction',
    4: 'Other recordable cases'
};

export const INJURY_TYPE = {
    1: 'Injury',
    2: 'Skin disorder',
    3: 'Respiratory condition',
    4: 'Poisoning',
    5: 'Hearing Loss',
    6: 'All other illness',
};

export const MOST_SERIOUS_OUTCOME_DEATH = 1;
export const DAYS_AWAY_FROM_WORK = 2;
export const JOB_TRANSFER_OR_RESTRICTION = 3;
export const OTHER_RECORDABLE_CASES = 4;
export const TIME_UNKNOWN = 1;
export const TIME_KNOWN = 0;



/** WEBPACK FOOTER **
 ** ./src/constants/caseDataConstants.js
 **/